// Display labels for flow trigger timing. The audit carries the raw
// Salesforce value; the UI shows plain words.
const TIMING_LABEL: Record<string, string> = {
  RecordBeforeSave: 'Before save',
  RecordAfterSave: 'After save',
  RecordBeforeDelete: 'Before delete',
  Scheduled: 'Scheduled',
  PlatformEvent: 'Platform event',
  None: 'None',
};

export function timingLabel(timing: string | null | undefined): string | null {
  if (!timing) return null;
  return TIMING_LABEL[timing] ?? timing;
}
